export default function downloadLink(link: string) {
  window.open(link, 'Download')
}
